import {
	amountFormatter,
	calculateNHFAmount,
	calculatePAYEAmount,
	calculateWHTAmount,
	calculatePensionAmount,
	calculateNetAmount,
	calculateCRA,
} from '../../utils/utils';
import {
	MimaText,
	MimaInput,
	ReceiptCheckBox as RCB,
	MimaButton,
	MimaDropdown,
	Modal,
	MimaDateInput,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import SuccessImg from '../../assets/img/success.png';
import { employeeStore } from '../../stores';
import React, { useState } from 'react';
import { Formik } from 'formik';

const AddEmployee = ({
	stage2,
	stage3,
	showStage2,
	showStage3,
	trackCreate,
	userInfoSchema,
	jobInfoSchema,
	bankInfoSchema,
	onSubmitUserInfo,
	onSubmitJobInfo,
	onSubmitBankInfo,
	success,
	setAccountName,
	accountName,
	banks,
	loading,
	setLoading,
	verifyAccountNumber,
	closeModal,
	showStage1,
	goBack,
	totalExtra,
}) => {
	const [group, setGroup] = useState({});

	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			{!success && (
				<>
					<MimaText variant="subtitle">Add Employee</MimaText>
					<div className={styles.crumbs}>
						<div
							className={`${styles.crumbs__main} ${
								!stage2 && !stage3 && styles.crumbs__active
							}`}
							onClick={showStage1}></div>
						<div
							className={`${styles.crumbs__main} ${
								stage2 && styles.crumbs__active
							}`}
							onClick={showStage2}></div>
						<div
							className={`${styles.crumbs__main} ${
								stage3 && styles.crumbs__active
							}`}
							onClick={showStage3}></div>
					</div>
					<div>
						{!stage2 && !stage3 && !success && (
							<>
								<MimaText align="center" mt={3}>
									Personal Information
								</MimaText>
								<Formik
									initialValues={{
										fullname: trackCreate?.userInfo?.firstname
											? `${trackCreate?.userInfo?.firstname} ${trackCreate?.userInfo?.lastname}`
											: '',
										mobile: trackCreate?.userInfo?.mobile || '',
										email: trackCreate?.userInfo?.email || '',
										gender: trackCreate?.userInfo?.gender || '',
									}}
									validationSchema={userInfoSchema}
									onSubmit={onSubmitUserInfo}>
									{({
										handleChange,
										handleBlur,
										handleSubmit,
										setFieldValue,
										values,
										errors,
										touched,
									}) => (
										<div>
											<MimaInput
												labelTitle="Full Name"
												type="text"
												placeholder="Enter Firstname and Lastname"
												id="fullname"
												name="fullname"
												value={values.fullname}
												onChange={handleChange}
												onBlur={handleBlur}
												error={errors.fullname}
												touched={touched.fullname}
											/>

											<MimaInput
												labelTitle="Employee Phone Number"
												type="tel"
												className={`${styles.form__input} ${
													touched.mobile ? styles.filled : null
												}`}
												placeholder="Enter Phone Number"
												name="mobile"
												value={values.mobile}
												onChange={handleChange}
												onBlur={handleBlur}
												error={errors.mobile}
												touched={touched.mobile}
											/>
											<MimaInput
												labelTitle="Enter Employee Email"
												type="text"
												className={`${styles.form__input} ${
													touched.email ? styles.filled : null
												}`}
												placeholder="Enter Employee Email"
												id="email"
												name="email"
												value={values.email}
												onChange={handleChange}
												onBlur={handleBlur}
												error={errors.email}
												touched={touched.email}
											/>

											<div className={styles.checks_group}>
												<MimaText ml={2} mb={2} variant="small">
													Gender
												</MimaText>
												<div className={styles.checks}>
													<RCB
														title="Male"
														id="MALE"
														name="gender"
														onChange={() => {
															setFieldValue('gender', 'MALE');
														}}
														checked={values.gender === 'MALE'}
														value="Male"
													/>
													<RCB
														title="Female"
														name="gender"
														onChange={() => {
															setFieldValue('gender', 'FEMALE');
														}}
														checked={values.gender === 'FEMALE'}
														id="FEMALE"
														value="Female"
													/>
												</div>
												{errors.gender ? (
													<div className={styles.error}>
														{''}
														{touched.gender && errors.gender}
														{''}
													</div>
												) : null}
											</div>
											<MimaButton
												title="Continue"
												type="submit"
												loading={loading}
												onClick={handleSubmit}
											/>
										</div>
									)}
								</Formik>
							</>
						)}
						{stage2 && (
							<>
								<MimaText align="center" mt={3}>
									Job Information
								</MimaText>
								<Formik
									initialValues={{
										employmentType: trackCreate?.jobInfo?.employmentType || '',
										settlementCycle: trackCreate?.settlementCycle || '',
										jobTitle: trackCreate?.jobInfo?.jobTitle || '',
										startDate: trackCreate?.jobInfo?.startDate || '',
										department: trackCreate?.jobInfo?.department || '',
										departmentName: trackCreate?.jobInfo?.department || '',
										employeeGroup: trackCreate?.jobInfo?.employeeGroup || '',
										employeeGroupName: trackCreate?.jobInfo?.employeeGroup || 0,
										basicSalary: trackCreate?.jobInfo?.basicSalary || 0,
										housingAllowance:
											trackCreate?.jobInfo?.housingAllowance || 0,
										transportAllowance:
											trackCreate?.jobInfo?.transportAllowance || 0,
										grossPay: trackCreate?.jobInfo?.grossPay || 0,
										otherDeductionAmount:
											trackCreate?.jobInfo?.otherDeductionAmount || 0,
										deductions: {
											tax: trackCreate?.jobInfo?.deductions.tax || false,
											pension:
												trackCreate?.jobInfo?.deductions.pension || false,
											nhf: trackCreate?.jobInfo?.deductions.nhf || false,
											wht: trackCreate?.jobInfo?.deductions.wht || false,
										},
									}}
									validationSchema={jobInfoSchema}
									onSubmit={onSubmitJobInfo}>
									{({
										handleChange,
										handleBlur,
										handleSubmit,
										setFieldValue,
										values,
										errors,
										touched,
									}) => (
										<div>
											<MimaDateInput
												labelTitle="Start date"
												name="startDate"
												value={values.startDate}
												onChange={text => {
													setFieldValue('startDate', text);
												}}
												onBlur={handleBlur}
											/>
											{/* <MimaDropdown
												labelTitle="Group(optional)"
												placeholder="Select"
												name="employeeGroup"
												currentValue={values.employeeGroupName}
												value={values.employeeGroupName}
												id="employeeGroup"
												mt={2}
												mb={2}
												onChange={data => {
													setFieldValue('employeeGroup', data.key);
													setFieldValue('employeeGroupName', data.value);
													setGroup(data?.data);
													if (group.jobTitle)
														setFieldValue('jobTitle', group.jobTitle);
													if (group.department?._id)
														setFieldValue('department', group?.department?._id);
													if (group.employmentType)
														setFieldValue(
															'employmentType',
															group.employmentType
														);
													if (group.grossPay && group.grossPay > 0) {
														setFieldValue('grossPay', group.grossPay);
														setFieldValue(
															'leaveAllowance',
															group.leaveAllowance
														);
														setFieldValue('quaterlyBonus', group.quaterlyBonus);
														setFieldValue(
															'performanceBonus',
															group.performanceBonus
														);
													}
												}}
												data={employeeStore.mapGroups}
												touched={touched.employeeGroup}
											/> */}

											<MimaDropdown
												labelTitle="Department"
												placeholder="Select"
												name="department"
												value={values.departmentName}
												id="department"
												onChange={data => {
													setFieldValue('department', data.key);
													setFieldValue('departmentName', data.value);
												}}
												data={employeeStore.mapDepartments}
												touched={touched.department}
											/>

											<MimaInput
												type="text"
												labelTitle="Job Title / Role"
												id="jobTitle"
												placeholder="Enter Job Title / Role"
												name="jobTitle"
												mt={2}
												mb={2}
												value={values.jobTitle}
												onChange={handleChange}
												onBlur={handleBlur}
												error={errors.jobTitle}
												touched={touched.jobTitle}
											/>
											<MimaInput
												type="number"
												labelTitle="Gross Salary(Month)"
												placeholder="Enter Gross Salary Per month"
												name="grossPay"
												mb={2}
												min={0}
												value={values.grossPay}
												onChange={handleChange}
												onBlur={handleBlur}
												error={errors.grossPay}
												touched={touched.grossPay}
											/>

											<div className={styles.checks_group}>
												<MimaText ml={2} mb={2} variant="small">
													Employment Type
												</MimaText>

												<div className={styles.checks}>
													<RCB
														title="FULLTIME"
														id="FULLTIME"
														name="employmentType"
														onChange={() => {
															setFieldValue('employmentType', 'FULLTIME');
														}}
														checked={values.employmentType === 'FULLTIME'}
														value="FULLTIME"
													/>
													<RCB
														title="CONTRACT"
														name="employmentType"
														id="CONTRACT"
														onChange={() => {
															setFieldValue('employmentType', 'CONTRACT');
														}}
														checked={values.employmentType === 'CONTRACT'}
														value="CONTRACT"
													/>
												</div>

												{errors.employmentType ? (
													<div className={styles.error}>
														{''}
														{touched.employmentType && errors.employmentType}
														{''}
													</div>
												) : null}
											</div>
											<>
												{values.employmentType === 'FULLTIME' && (
													<>
														<MimaInput
															type="number"
															labelTitle="Basic Salary(Month)"
															placeholder="Enter Basic Salary Per month"
															name="basicSalary"
															mb={2}
															min={0}
															max={values.grossPay}
															value={values.basicSalary}
															onChange={handleChange}
															onBlur={handleBlur}
															error={errors.basicSalary}
															touched={touched.basicSalary}
														/>

														<MimaInput
															type="number"
															labelTitle="House Allowance(Month)"
															placeholder="Enter House Allowance Per month"
															name="housingAllowance"
															mb={2}
															min={0}
															value={values.housingAllowance}
															onChange={handleChange}
															onBlur={handleBlur}
															error={errors.housingAllowance}
															touched={touched.housingAllowance}
														/>

														<MimaInput
															type="number"
															labelTitle="Transportation Allowance(Month)"
															placeholder="Enter Transportation Allowance Per month"
															name="transportAllowance"
															mb={2}
															min={0}
															value={values.transportAllowance}
															onChange={handleChange}
															onBlur={handleBlur}
															error={errors.transportAllowance}
															touched={touched.transportAllowance}
														/>
														<MimaInput
															type="text"
															labelTitle="Others (Month)"
															placeholder="Other Allowance Per month"
															name="other"
															disabled={true}
															mb={2}
															min={0}
															value={amountFormatter().format(
																values.grossPay -
																	(values.transportAllowance +
																		values.basicSalary +
																		values.housingAllowance)
															)}
															onChange={handleChange}
															onBlur={handleBlur}
															error={errors.transportAllowance}
															touched={touched.transportAllowance}
														/>
													</>
												)}

												{/* {values.employmentType === 'FULLTIME' && (
													<>
														<MimaInput
															type="number"
															labelTitle="Annual Leave Allowance"
															placeholder="Annual Leave Allowance"
															name="leaveAllowance"
															mb={2}
															min={0}
															value={values.leaveAllowance}
															onChange={handleChange}
															onBlur={handleBlur}
															touched={touched.leaveAllowance}
														/>
													</>
												)} */}

												<div className={styles.checks_group}>
													<MimaText ml={2} mb={2} variant="small">
														Kindly select what you want to be deducted from the
														gross salary
													</MimaText>
													<div className={styles.checks}>
														{values.employmentType === 'FULLTIME' ? (
															<>
																<RCB
																	title="Paye Tax"
																	id="deductions.tax"
																	name="deductions.tax"
																	onChange={() => {
																		setFieldValue(
																			'deductions.tax',
																			!values.deductions.tax
																		);
																	}}
																	checked={values.deductions.tax}
																	value={true}
																/>

																<RCB
																	title="Pension"
																	name="deductions.pension"
																	onChange={() => {
																		setFieldValue(
																			'deductions.pension',
																			!values.deductions.pension
																		);
																	}}
																	checked={values.deductions.pension}
																	id="deductions.pension"
																	value={true}
																/>
																<RCB
																	title="NHF"
																	name="deductions.nhf"
																	onChange={() => {
																		setFieldValue(
																			'deductions.nhf',
																			!values.deductions.nhf
																		);
																	}}
																	checked={values.deductions.nhf}
																	id="deductions.nhf"
																	value={true}
																/>
															</>
														) : (
															<RCB
																title="WHT"
																name="deductions.wht"
																onChange={() => {
																	setFieldValue(
																		'deductions.wht',
																		!values.deductions.wht
																	);
																}}
																checked={values.deductions.wht}
																id="deductions.wht"
																value={true}
															/>
														)}
													</div>
													{values.deductions.tax &&
														values.employmentType === 'FULLTIME' && (
															<MimaInput
																type="text"
																labelTitle="Paye Tax Per month(Month)"
																disabled={true}
																name="taxAmount"
																mb={2}
																min={0}
																value={amountFormatter().format(
																	calculatePAYEAmount({
																		grossPay: values.grossPay,
																		chargedPension: values.deductions?.pension,
																		chargedNHF: values.deductions?.nhf,
																		basicSalary: values.basicSalary,
																		housingAllowance: values.housingAllowance,
																		transportAllowance:
																			values.transportAllowance,
																	})
																)}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
														)}
													{values.deductions.wht &&
														values.employmentType === 'CONTRACT' && (
															<MimaInput
																type="text"
																labelTitle="Withholding Tax Per month(Month)"
																disabled={true}
																name="whtAmount"
																mb={2}
																min={0}
																value={amountFormatter().format(
																	calculateWHTAmount(values.grossPay)
																)}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
														)}
													{values.deductions.pension &&
														values.employmentType === 'FULLTIME' && (
															<MimaInput
																type="text"
																labelTitle="Pension Per month(Month)"
																disabled={true}
																name="pensionAmount"
																mb={2}
																min={0}
																value={amountFormatter().format(
																	calculatePensionAmount({
																		basicSalary: values.basicSalary,
																		housingAllowance: values.housingAllowance,
																		transportAllowance:
																			values.transportAllowance,
																	})
																)}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
														)}
													{values.deductions.nhf &&
														values.employmentType === 'FULLTIME' && (
															<MimaInput
																type="text"
																labelTitle="NHF Per month(Month)"
																disabled={true}
																name="nhfAmount"
																mb={2}
																min={0}
																value={amountFormatter().format(
																	calculateNHFAmount({
																		basicSalary: values.basicSalary,
																	})
																)}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
														)}
													{values.deductions.tax &&
														values.employmentType === 'FULLTIME' && (
															<MimaInput
																type="text"
																labelTitle="Annual Tax Relief"
																disabled={true}
																name="taxRelief"
																mb={2}
																min={0}
																value={amountFormatter().format(
																	calculateCRA({
																		grossPay: values.grossPay,
																		chargedPension: values.deductions?.pension,
																		chargedNHF: values.deductions?.nhf,
																		basicSalary: values.basicSalary,
																		housingAllowance: values.housingAllowance,
																		transportAllowance:
																			values.transportAllowance,
																	}).taxRelief
																)}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
														)}
													{values.deductions.tax &&
														values.employmentType === 'FULLTIME' && (
															<MimaInput
																type="text"
																labelTitle="20% Consolidated Salary"
																disabled={true}
																name="taxRelief"
																mb={2}
																min={0}
																value={amountFormatter().format(
																	calculateCRA({
																		grossPay: values.grossPay,
																		chargedPension: values.deductions?.pension,
																		chargedNHF: values.deductions?.nhf,
																		basicSalary: values.basicSalary,
																		housingAllowance: values.housingAllowance,
																		transportAllowance:
																			values.transportAllowance,
																	}).salaryRelief
																)}
																onChange={handleChange}
																onBlur={handleBlur}
															/>
														)}
													<MimaInput
														type="number"
														labelTitle="Other Deduction(Month)"
														placeholder="Enter Gross Salary Per month"
														name="otherDeductionAmount"
														mb={2}
														min={0}
														value={values.otherDeductionAmount}
														onChange={handleChange}
														onBlur={handleBlur}
														touched={touched.otherDeductionAmount}
													/>{' '}
													<div className={styles.checks_group}>
														<MimaText ml={2} mb={2} variant="small">
															Payment Cycle
														</MimaText>

														<div className={styles.checks}>
															<RCB
																title="WEEKLY"
																id="WEEKLY"
																name="settlementCycle"
																onChange={() => {
																	setFieldValue('settlementCycle', 'WEEKLY');
																}}
																checked={values.settlementCycle === 'WEEKLY'}
																value="WEEKLY"
															/>
															<RCB
																title="BI-WEEKLY"
																id="BI-WEEKLY"
																name="settlementCycle"
																onChange={() => {
																	setFieldValue('settlementCycle', 'BI-WEEKLY');
																}}
																checked={values.settlementCycle === 'BI-WEEKLY'}
																value="BI-WEEKLY"
															/>
															<RCB
																title="MONTHLY"
																id="MONTHLY"
																name="settlementCycle"
																onChange={() => {
																	setFieldValue('settlementCycle', 'MONTHLY');
																}}
																checked={values.settlementCycle === 'MONTHLY'}
																value="MONTHLY"
															/>
														</div>

														{errors.settlementCycle ? (
															<div className={styles.error}>
																{''}
																{touched.settlementCycle &&
																	errors.settlementCycle}
																{''}
															</div>
														) : null}
													</div>
													<MimaButton
														title={`Expected Monthly Net Pay: ${calculateNetAmount(
															values
														)}`}
														variant="text"
														type="button"
													/>
												</div>
											</>

											<MimaButton
												title="Continue"
												type="submit"
												loading={loading}
												onClick={handleSubmit}
											/>
										</div>
									)}
								</Formik>
							</>
						)}
						{stage3 && (
							<>
								<MimaText align="center" mt={3}>
									Bank Account Information
								</MimaText>
								<Formik
									initialValues={{
										bankCode: '',
										bank: '',
										accountNumber: '',
									}}
									validationSchema={bankInfoSchema}
									onSubmit={onSubmitBankInfo}>
									{({
										handleChange,
										handleBlur,
										handleSubmit,
										setFieldValue,
										values,
										errors,
										touched,
									}) => (
										<div>
											<MimaDropdown
												labelTitle="Bank Name"
												placeholder="-Select-"
												data={banks}
												id="bankCode"
												onChange={data => {
													setFieldValue('bankCode', data.id);
													setFieldValue('bank', data.value);
												}}
												name="bankCode"
												onBlur={handleBlur}
												error={errors.bankCode}
												touched={touched.bankCode}
											/>
											<MimaInput
												type="text"
												labelTitle="Account Number"
												name="accountNumber"
												value={values.accountNumber}
												onChange={e => {
													setLoading(true);
													verifyAccountNumber({
														accountNumber: e.target.value,
														beneficiaryBank: values.bankCode,
													}).then(data => {
														setAccountName(data);
														setLoading(false);
													});
													handleChange(e);
												}}
												onBlur={handleBlur}
												error={errors.accountNumber}
												touched={touched.accountNumber}
												mt={2}
											/>

											<MimaInput
												type="text"
												disabled={true}
												labelTitle="Account Name"
												name="accountName"
												value={accountName}
												placeholder={accountName}
												onChange={handleChange}
												onBlur={handleBlur}
											/>

											<MimaButton
												disabled={loading}
												loading={loading}
												title="Continue"
												type="submit"
												onClick={handleSubmit}
											/>
										</div>
									)}
								</Formik>
							</>
						)}
					</div>
				</>
			)}
			{success && (
				<>
					<img src={SuccessImg} className={styles.modal__img} />
					<MimaText align="center" mb={3}>
						Employee <br /> successfully Added
					</MimaText>

					<MimaButton title="Continue" onClick={closeModal} />
				</>
			)}
		</Modal>
	);
};

export default AddEmployee;
